export const LAYOUT_VIEW_MODE = 'layout';
export const GRID_VIEW_MODE = 'grid';
export const PROOF_BANNER_VIEW_MODE_KEY = 'proof_banner_view_mode';
export const PROOF_BANNER_PER_PAGE_KEY = 'proof_banner_per_page';
export const VIDEO_PROOF_BANNER_VIEW_MODE_KEY = 'video_proof_banner_view_mode';
export const BRIEFS_VIEW_MODE_KEY = 'briefs-view-toggle';
export const BRIEFS_SHOW_COVER_IMAGES_KEY = 'briefs-show-cover-images';
export const BRIEFS_GROUP_BY_KEY = 'briefs-group-by';
